import { render, staticRenderFns } from "./UserInfoResign.vue?vue&type=template&id=0264328d&"
import script from "./UserInfoResign.vue?vue&type=script&lang=js&"
export * from "./UserInfoResign.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoResign.vue?vue&type=style&index=0&id=0264328d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports